// extracted by mini-css-extract-plugin
export default {"zoomModal":"n4-z"};